import { createContext, useContext, useEffect, useState } from "react";
import api, { getToken, setToken, clearToken } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Le token stocké est injecté par l'intercepteur de api.js ; si aucun token
    // n'est présent, un éventuel cookie same-site sert encore de repli. Un token
    // rejeté est purgé par l'intercepteur de réponse ; une panne réseau
    // (démarrage à froid de Cloud Run) le laisse en place pour le rechargement.
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const loginUser = (data) => {
    if (data?.access_token) setToken(data.access_token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role,
              must_change_password: !!data.must_change_password });
  };

  const updateUser = (partial) => setUser((u) => ({ ...u, ...partial }));

  const logoutUser = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.warn("Logout request failed:", e?.message);
    }
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loginUser, logoutUser, updateUser, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
